import { render, staticRenderFns } from "./order-line-item.vue?vue&type=template&id=477b8f0e&scoped=true&lang=pug&"
import script from "./order-line-item.vue?vue&type=script&lang=js&"
export * from "./order-line-item.vue?vue&type=script&lang=js&"
import style0 from "./order-line-item.vue?vue&type=style&index=0&id=477b8f0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477b8f0e",
  null
  
)

export default component.exports